import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Vector3LineComponent } from "shared-ui-components/lines/vector3LineComponent";
import { Color3LineComponent } from "shared-ui-components/lines/color3LineComponent";
import { Color3 } from "core/Maths/math.color";
export class Vector3PropertyTabComponent extends React.Component {
    render() {
        const asColor3 = new Color3(this.props.inputBlock.value.x, this.props.inputBlock.value.y, this.props.inputBlock.value.z);
        const tempObject = {
            color: asColor3,
        };
        return (_jsxs(_Fragment, { children: [_jsx(Vector3LineComponent, { lockObject: this.props.lockObject, label: "Value", target: this.props.inputBlock, propertyName: "value", onChange: () => {
                        this.props.globalState.stateManager.onUpdateRequiredObservable.notifyObservers(this.props.inputBlock);
                        this.props.globalState.stateManager.onRebuildRequiredObservable.notifyObservers();
                    } }), _jsx(Color3LineComponent, { lockObject: this.props.lockObject, label: "Pick from color", target: tempObject, propertyName: "color", onChange: () => {
                        this.props.inputBlock.value.x = tempObject.color.r;
                        this.props.inputBlock.value.y = tempObject.color.g;
                        this.props.inputBlock.value.z = tempObject.color.b;
                        this.props.globalState.stateManager.onUpdateRequiredObservable.notifyObservers(this.props.inputBlock);
                        this.props.globalState.stateManager.onRebuildRequiredObservable.notifyObservers();
                    } })] }));
    }
}
//# sourceMappingURL=vector3PropertyTabComponent.js.map